/**
 * Class for the online service
 */
var OnlineService = /** @class */ (function () {
    /**
     * Constructs a OnlineService
     */
    function OnlineService() {
        /** Keeps the online/offline state */
        this._isOnline = true;
        /*
        Observable.fromEvent(window, 'offline').subscribe(() => {
            this._isOnline = false;
        });
        Observable.fromEvent(window, 'online').subscribe(() => {
            this._isOnline = true;
        });*/
    }
    /**
     * Check if application is online
     */
    OnlineService.prototype.isOnline = function () {
        return navigator.onLine;
    };
    return OnlineService;
}());
export { OnlineService };
